import React, { useEffect } from "react";
import { Box, Typography, styled, keyframes } from "@mui/material";
import { SparkleGlyph } from "./SparkleGlyph";

interface CalculatingFitProps {
  onComplete: () => void;
  /** Italic label under the sparkles. */
  label?: string;
}

const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  40% { transform: translateY(-7px); }
`;

const Container = styled(Box, {
  label: "CalculatingFitContainer",
})(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 10,
  marginTop: 2,
}));

const SparkleRow = styled(Box, {
  label: "CalculatingFitSparkleRow",
})(() => ({
  display: "flex",
  gap: 8,
  alignItems: "center",
}));

const Sparkle = styled(Box, {
  label: "CalculatingFitSparkle",
  shouldForwardProp: (prop) => prop !== "delay",
})<{ delay: number }>(({ delay }) => ({
  display: "flex",
  animation: `${bounce} 0.7s ${delay}s ease-in-out infinite`,
}));

const Label = styled(Typography, {
  label: "CalculatingFitLabel",
})(() => ({
  fontFamily: "Proxima Nova, sans-serif",
  fontStyle: "italic",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "22px",
  color: "#fff5cc",
  textAlign: "center",
}));

const SPARKLE_DELAYS = [0, 0.15, 0.3];

export const CalculatingFit = ({
  onComplete,
  label = "Finding your fit…",
}: CalculatingFitProps) => {
  useEffect(() => {
    const timer = setTimeout(onComplete, 2000);
    return () => clearTimeout(timer);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container>
      <SparkleRow>
        {SPARKLE_DELAYS.map((delay) => (
          <Sparkle key={delay} delay={delay}>
            <SparkleGlyph size={16} />
          </Sparkle>
        ))}
      </SparkleRow>
      <Label>{label}</Label>
    </Container>
  );
};
